import React from 'react';
import PropTypes from 'prop-types';
import CheckedIcon from '@images/checked-icon.svg';
import * as Styled from './SavedAddressesItem.style';

const SavedAddressesItem = ({
  data: address,
  isHighlighted,
  onSelect,
  ...rest
}) => {
  function selectAddress() {
    onSelect(address.id);
  }

  return (
    <Styled.Item highlighted={isHighlighted} onClick={selectAddress} {...rest}>
      <Styled.Icon src={CheckedIcon} alt="React Logo" />
      <div className="item">
        <Styled.Title>{address.name}</Styled.Title>
        <Styled.Address>{address.line}</Styled.Address>
      </div>
    </Styled.Item>
  );
};

SavedAddressesItem.propTypes = {
  data: PropTypes.shape().isRequired,
  onSelect: PropTypes.func.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
};

export default SavedAddressesItem;
